import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/serial`;

export function fetchProductSerialList(payload: { page: number }) {
  return axs({ url: `${basePath}`, method: 'get', params: payload });
}

export function updateProductSerial(payload: { serialNo: string }) {
  return axs({ url: `${basePath}`, method: 'post', data: payload });
}

export function deleteProductSerial(payload: { serialNo: string }) {
  return axs({ url: `${basePath}`, method: 'delete', data: payload });
}
